module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RD8Cu3/tc-custom/9781439617960.jpg?1679091106395",
      "alt": "This image is the cover for the book Hockey in Providence, Images of Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hockey in Providence, Images of Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Providence has an old and rich hockey tradition. The Providence Reds were one of the first professional hockey teams in the United States. In their 51-year history (1926�1977), the Reds won seven playoff championships, including four Calder Cup titles. The Reds were the first minor-league hockey team to operate for 50 seasons. The Providence Bruins, established in the 1992�1993 season, carry on the city�s great hockey legacy and gave Providence its fifth Calder Cup title. Several Hockey Hall of Famers have played for Providence-based teams, including Bobby Bauer, Hector �Toe� Blake, Johnny Bower, Frank Brimsek, Eddie Giacomin, Rod Langway, Milt Schmidt, and Lorne �Gump� Worsley.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Mancuso\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jim Mancuso is a member of the Society for International Hockey Research and the Rhode Island Reds Heritage Society. He has written several other books on minor-league hockey, including Hockey in the Capital District, Hockey in Charlotte, Hockey in Springfield, and Hockey in Syracuse.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0